﻿import config from "../config"
const baseUrl = config.base_url + "gy_garden_data_task/"
export default {
    list: {
        url:  baseUrl + "list",
        type: "get",
    },
    page: {
        url:  baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    remove:{
        url:  baseUrl + "delete",
        type: "get",
    },
    save:{
        url:  baseUrl + "save",
        type: "post",
    },
    execute:{
        url:  baseUrl + "execute/{id}",
        type: "get",
    }
}

